import { useEffect } from "react";
import { AccountSearchView } from "./AccountSearchView";
import { testIds } from "./consts";
import { LoadingIndicator } from "@dealer-center/core-custom-components";
import { AccountSearchProvider } from "@dealer-center/ddc-pages-account-search-context";
import { useGetUser } from "@dealer-center/ddc-api-user-fetch";

export const AccountSearchController = () => {
  const { isLoading } = useGetUser();

  useEffect(() => {
    document.title = "Account Search";
  }, []);

  if (isLoading) {
    return (
      <LoadingIndicator
        actionName="Account Search Loading"
        data-testid={testIds.loadingSpinnerTestId}
      />
    );
  }

  return (
    <AccountSearchProvider>
      <AccountSearchView />
    </AccountSearchProvider>
  );
};

export default AccountSearchController;
